import { render } from "./YTComp.html?vue&type=template&id=03c7f685&scoped=true&ts=true&external"
import script from "./YTComp.ts?vue&type=script&lang=ts&external"
export * from "./YTComp.ts?vue&type=script&lang=ts&external"

import "./YTComp.scss?vue&type=style&index=0&id=03c7f685&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c7f685"]])

export default __exports__